// extracted by mini-css-extract-plugin
export var category = "newsDetails-module--category--1244d";
export var center = "newsDetails-module--center--55988";
export var contPagination = "newsDetails-module--contPagination--3c4f9";
export var ctaTitle = "newsDetails-module--ctaTitle--62621";
export var date = "newsDetails-module--date--93d24";
export var imageWrapper = "newsDetails-module--imageWrapper--54dd1";
export var insideHeading = "newsDetails-module--insideHeading--90ed9";
export var link = "newsDetails-module--link--45cbe";
export var name = "newsDetails-module--name--573b9";
export var newsBlock = "newsDetails-module--newsBlock--c59de";
export var newsBody = "newsDetails-module--newsBody--66bbf";
export var newsDetailsContainer = "newsDetails-module--newsDetailsContainer--e8a62";
export var newsFooter = "newsDetails-module--newsFooter--e115a";
export var newsHeading = "newsDetails-module--newsHeading--173a2";
export var newsItem = "newsDetails-module--newsItem--9b695";
export var pageIndicator = "newsDetails-module--pageIndicator--119a2";
export var photo = "newsDetails-module--photo--8d347";
export var speakers = "newsDetails-module--speakers--2a690";
export var speakersHeader = "newsDetails-module--speakersHeader--fead0";
export var subHead = "newsDetails-module--subHead--08bb9";
export var text = "newsDetails-module--text--05cdf";
export var title = "newsDetails-module--title--f93dd";
export var videoWrapper = "newsDetails-module--videoWrapper--75bb1";